// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__BOFu3","errorLogs":"styles_errorLogs__2j4yM"};